import {useEffect, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";

import {clientRpRequestMeta} from "../../../client/client_rp_request_meta";
import {IRPStore} from "../../app/rp_reducer";
import {fetchMarketplaceRegions} from "../actions/fetch_marketplace_regions";

export const useMarketplaceRegions = (regionSlug?: string) => {
    const marketplaceRegions = useSelector((state: IRPStore) => state.marketplace.regions);
    const dispatch = useDispatch();

    useEffect(() => {
        const ctx = {
            meta: clientRpRequestMeta
        };

        dispatch(fetchMarketplaceRegions(ctx));
    }, []);

    const regionBySlug = useMemo(() => marketplaceRegions?.find((marketplaceRegion) => marketplaceRegion.slug === regionSlug), [marketplaceRegions]);

    return {
        marketplaceRegions,
        regionBySlug
    };
};
